import { lazy, Suspense } from "react";

const CatalogSelectorInner = lazy(() =>
  import(
    "pages/Explore/components/Sidebar/selectors/CatalogSelector/CatalogSelector.index"
  ).then(m => ({ default: m.CatalogSelector }))
);

// Deferred so importing this from App.tsx doesn't drag the Catalog2 tree into the main bundle.
export const LazyCatalogSelector = () => (
  <Suspense fallback={null}>
    <CatalogSelectorInner />
  </Suspense>
);
